const TRANSACTION_ID_PATTERN =
  /(?:\s|<br\s*\/?>|&nbsp;)*Transaction ID:\s*([^\s<]+)\s*(<\/p>)?\s*$/i;

export const splitTransactionId = (description = '') => {
  const text = description || '';
  const match = text.match(TRANSACTION_ID_PATTERN);
  if (!match) return { description: text, transactionId: '' };

  return {
    description: text
      .replace(TRANSACTION_ID_PATTERN, match[2] || '')
      .replace(/(<p>\s*<\/p>)+$/i, '')
      .trim(),
    transactionId: match[1],
  };
};
